import React, { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { acceptGroupInviteEmail } from '../../api/groupApi';
import { useToast } from '../../components/Toaster/use-toast';
import { stashPendingInvite } from '../../utils/pendingInvites';

export default function AcceptEmailInviteLink() {
  const navigate = useNavigate();
  const [sp] = useSearchParams();
  const token = sp.get('token');
  const { toast } = useToast();
  const [status, setStatus] = useState('loading');
  const [message, setMessage] = useState('');

  useEffect(() => {
    let alive = true;

    (async () => {
      if (!token) {
        setStatus('error');
        setMessage('Missing invite token.');
        return;
      }

      try {
        const res = await acceptGroupInviteEmail(token);

        if (!alive) return;
        setStatus('ok');
        setMessage(`You’ve joined "${res.groupName}" in ${res.orgName}.`);

        setTimeout(() => navigate('/conversation-type', { replace: true }), 1200);
      } catch (e) {
        if (!alive) return;

        const code = e?.response?.data?.code;
        const err = e?.response?.data?.error || e?.message || 'Could not accept invite.';

        if (code === 'LOGIN_REQUIRED') {
            stashPendingInvite({ token, mode: 'email' });
          navigate('/auth', { replace: true });
          return;
        }

        setStatus('error');
        setMessage(err);
      }
    })();

    return () => { alive = false; };
  }, [token, navigate, toast]);

  return (
    <div style={{ padding: 24, maxWidth: 520, margin: '0 auto' }}>
      <h2 style={{ marginBottom: 8 }}>
        {status === 'loading' ? 'Joining group…' : status === 'ok' ? 'Welcome!' : 'Invite link problem'}
      </h2>
      <div style={{ opacity: 0.8 }}>{message}</div>
    </div>
  );
}
